import { IFilterElement } from "@saleor/components/Filter";
import { findInEnum, findValueInEnum, maybe } from "@saleor/misc";
import {
  PageEventFilterKeys,
  PageEventListFilterOpts
} from "@saleor/pageManage/components/PageEventListPage/filters";
import {
  PageEventListUrlFilters,
  PageEventListUrlFiltersEnum,
  PageEventListUrlFiltersWithMultipleValuesEnum,
  PageEventListUrlQueryParams
} from "@saleor/pageManage/urls";
import {
  LanguageCodeFilter,
  PageUserEventsEnum,
  UserOperatePageEventFilterInput
} from "@saleor/types/globalTypes";
import {
  createFilterTabUtils,
  createFilterUtils,
  dedupeFilter,
  getMultipleEnumValueQueryParam
} from "@saleor/utils/filters";

export const PAGEEVENT_FILTERS_KEY = "pageeventFilters";

export function getFilterVariables(
  params: PageEventListUrlFilters
): UserOperatePageEventFilterInput {
  return {
    operateType: maybe(() =>
      params.operateType.map(operateType =>
        findInEnum(operateType, PageUserEventsEnum)
      )
    ),
    languageCode: maybe(() =>
      params.languageCode.map(languageCode =>
        findInEnum(languageCode, LanguageCodeFilter)
      )
    ),
    search: params.query
  };
}

export function getFilterOpts(
  params: PageEventListUrlFilters
): PageEventListFilterOpts {
  return {
    operateType: {
      active: maybe(() => params.operateType !== undefined, false),
      value: maybe(
        () =>
          dedupeFilter(
            params.operateType.map(operateType =>
              findValueInEnum(operateType, PageUserEventsEnum)
            )
          ),
        []
      )
    },
    languageCode: {
      active: maybe(() => params.languageCode !== undefined, false),
      value: maybe(
        () =>
          dedupeFilter(
            params.languageCode.map(languages =>
              findValueInEnum(languages, LanguageCodeFilter)
            )
          ),
        []
      )
    }
  };
}
export function getFilterQueryParam(
  filter: IFilterElement<PageEventFilterKeys>
): PageEventListUrlFilters {
  const { name } = filter;
  switch (name) {
    case PageEventFilterKeys.operateType:
      return getMultipleEnumValueQueryParam(
        filter,
        PageEventListUrlFiltersWithMultipleValuesEnum.operateType,
        PageUserEventsEnum
      );
    case PageEventFilterKeys.languageCode:
      return getMultipleEnumValueQueryParam(
        filter,
        PageEventListUrlFiltersWithMultipleValuesEnum.languageCode,
        LanguageCodeFilter
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<PageEventListUrlFilters>(PAGEEVENT_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  PageEventListUrlQueryParams,
  PageEventListUrlFilters
>(PageEventListUrlFiltersEnum);
